/* Asakusa — compte à rebours des précommandes.
   Un seul script pour toute la page : il balaie les [data-asa-count], donc il
   couvre aussi bien la section « Précommandes à la une » que les cartes des
   grilles de collection et celles injectées par la wishlist.

   Piège évité : écrire dans les <b> déclenche l'observateur de mutations, ce
   qui rappellerait tick() en boucle. D'où le drapeau `busy` + l'écriture
   conditionnelle (on ne touche au DOM que si la valeur a changé). */
(function () {
  'use strict';

  var busy = false;
  var queued = false;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function set(el, sel, value) {
    var node = el.querySelector(sel);
    if (node && node.textContent !== value) node.textContent = value;
  }

  function tick() {
    busy = true;
    var now = Date.now();
    var list = document.querySelectorAll('[data-asa-count]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el._asaTarget === undefined) {
        /* Deux formats acceptés : une date (précommandes, minuit implicite) ou
           un epoch en secondes (loteries : le tirage a une HEURE précise, et
           l'epoch évite les écarts de fuseau d'un parsing ISO). */
        var raw = el.dataset.asaCount;
        el._asaTarget = /^\d+$/.test(raw) ? raw * 1000 : new Date(raw + 'T00:00:00').getTime();
      }
      var diff = el._asaTarget - now;
      if (isNaN(diff) || diff <= 0) { el.classList.add('is-over'); continue; }
      var d = Math.floor(diff / 86400000);
      set(el, '[data-d]', pad(d));
      set(el, '[data-h]', pad(Math.floor(diff % 86400000 / 3600000)));
      set(el, '[data-m]', pad(Math.floor(diff % 3600000 / 60000)));
      set(el, '[data-s]', pad(Math.floor(diff % 60000 / 1000)));
      el.classList.remove('is-over');
      /* Pas de variante dorée sous 7 jours : tous les compteurs ont le même
         habillage navy (demande Simon 30/08). */
      el.classList.remove('is-soon');
    }
    busy = false;
  }

  function schedule() {
    if (busy || queued) return;
    queued = true;
    /* setTimeout et pas requestAnimationFrame : rAF est gelé quand l'onglet
       est en arrière-plan, et les cartes de la wishlist arrivent parfois
       pendant ce gel. */
    setTimeout(function () { queued = false; tick(); }, 50);
  }

  tick();
  /* Cadence : 30 s suffisent pour j/h/min, mais un compteur qui affiche les
     secondes (loterie) doit battre la seconde. On ne paie le timer rapide que
     si un tel compteur existe sur la page. */
  setInterval(tick, document.querySelector('[data-asa-count] [data-s]') ? 1000 : 30000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  }
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
